import { useEffect, useRef, useState } from "react";

const EASE = (t) => 1 - Math.pow(1 - t, 3);
const DURATION = 1100;
const GAP = 0.08; // فتحة صغيرة أسفل الحلقة كما في الصورة المرجعية

// عدّاد Neu ثنائي الطبقة: قرص خارجي مرتفع (shadow-neu) + قوس ملوّن على الحد + قرص داخلي غائر (shadow-neu-in) للرقم.
export const RingGauge = ({ value = 0, total = 0, size = 140, tone = "#10b981", label, icon: Icon, testId }) => {
  const stroke = Math.round(size * 0.095);
  const radius = (size - stroke) / 2 - 2;
  const circumference = 2 * Math.PI * radius;
  const track = circumference * (1 - GAP);
  const [shown, setShown] = useState(0);
  const fromRef = useRef(0);

  // الإطار/الخلفية يظهران فورًا وثابتين؛ الأنيميشن للأرقام فقط: عدّ تصاعدي عند الدخول وانزلاق سلس عند تغيّر القيمة.
  useEffect(() => {
    let frame;
    const from = fromRef.current;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / DURATION, 1);
      const cur = p < 1 ? from + (value - from) * EASE(p) : value;
      fromRef.current = cur;
      setShown(cur);
      if (p < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [value]);

  const ratio = total > 0 ? Math.min(Math.max(shown / total, 0), 1) : 0;
  const innerSize = Math.round(size * 0.72);

  return (
    <div className="relative inline-flex items-center justify-center rounded-full bg-background shadow-neu"
         style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="absolute inset-0 pointer-events-none"
           style={{ transform: `rotate(${90 + GAP * 180}deg)`, filter: `drop-shadow(0 2px 4px ${tone}55)` }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={stroke} strokeLinecap="round"
                className="stroke-foreground/[.06]" strokeDasharray={`${track} ${circumference}`} />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={stroke} strokeLinecap="round"
                stroke={tone} strokeDasharray={`${track * ratio} ${circumference}`} />
      </svg>
      <div className="relative flex flex-col items-center justify-center rounded-full bg-background shadow-neu-in leading-none"
           style={{ width: innerSize, height: innerSize }}>
        {Icon ? <Icon className="mb-1 h-5 w-5" style={{ color: tone }} strokeWidth={2.6} /> : null}
        <span className="font-black tracking-tight text-foreground" style={{ fontSize: size * 0.32 }}
              data-testid={`${testId}-value`}>{Math.round(shown)}</span>
        {label ? (
          <span className="mt-0.5 text-[10px] font-bold text-muted-foreground">{label}</span>
        ) : null}
      </div>
    </div>
  );
};
